import React from 'react';
import GlobalStyles, { StyledToastContainer } from './styles/GlobalStyles.styles';
import Router from './Router';
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from './context/authContext';
import 'react-toastify/dist/ReactToastify.min.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import '@xyflow/react/dist/style.css';
import { TemporaryChatContextProvider } from './context/temporaryChatContext';
// import { GoogleOAuthProvider } from '@react-oauth/google';
const App = () => {
  return (
    <>
      <BrowserRouter>
        <AuthContextProvider>
          <TemporaryChatContextProvider>
            <GlobalStyles />
            <Router />
            <StyledToastContainer />
          </TemporaryChatContextProvider>
        </AuthContextProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
